package top.wcpe.allincore.ui.runtime.internal.log

/** JS：委托 console.error（浏览器 / Node 皆可用），带上 logger 名前缀便于定位来源。 */
internal actual class UiLog actual constructor(private val name: String) {
    actual fun error(message: String, error: Throwable?) {
        if (error != null) {
            console.error("[$name] $message", error)
        } else {
            console.error("[$name] $message")
        }
    }

    actual fun warn(message: String, error: Throwable?) {
        if (error != null) {
            console.warn("[$name] $message", error)
        } else {
            console.warn("[$name] $message")
        }
    }

    actual fun debug(message: String) {
        console.log("[$name] $message")
    }

    actual fun info(message: String) {
        console.info("[$name] $message")
    }
}
